import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { MatDialog } from '@angular/material/dialog';
import * as L from 'leaflet';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { MatDrawer } from '@angular/material/sidenav';
import { RetriveReportsFetchComponent } from 'src/app/shared/components/retrive-reports-fetch/retrive-reports-fetch.component';
import { ConfirmVoyageNumberComponent } from 'src/app/shared/components/confirm-voyage-number/confirm-voyage-number.component';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { ForceApprovePopupComponent } from 'src/app/shared/components/force-approve-popup/force-approve-popup.component';
import { UploadfileValidationComponent } from 'src/app/shared/components/uploadfile-validation/uploadfile-validation.component';
import { AproveErrorpopupComponent } from 'src/app/shared/components/aprove-errorpopup/aprove-errorpopup.component';
import { PortsPopupComponent } from 'src/app/modules/request-form/pages/ports-popup/ports-popup.component';
import { ReportVerifyPopupComponent } from 'src/app/shared/components/report-verify-popup/report-verify-popup.component';
import { ViewDraftEmailPopupComponent } from 'src/app/shared/components/view-draft-email-popup/view-draft-email-popup.component';
import { DraftEmailConfirmPopupComponent } from 'src/app/shared/components/view-draft-email-popup/draft-email-confirm-popup.component';
import { IgnoreErrorPopupComponent } from 'src/app/shared/components/view-draft-email-popup/ignore-error-popup.component';
import html2canvas from 'html2canvas';
import emailjs from '@emailjs/browser';
import { isMerakiAdminUser } from 'src/app/shared/helpers/auth_guards/meraki-admin.util';
import { PortMailService } from 'src/app/shared/service/port-mail/port-mail.service';

@Component({
  selector: 'app-master-newform',
  templateUrl: './master-newform.component.html',
  styleUrls: ['./master-newform.component.scss'],
})
export class MasterNewformComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  requestForm!: FormGroup;
  formSubmitted: boolean = false;
  isUpload: boolean = false;
  errorAvailable: boolean = false;
  lastReport: any = {};
  vesselTypeOptions = [
    { label: 'Bulk Carrier', value: 'Bulk Carrier' },
    { label: 'General Cargo', value: 'General Cargo' },
    { label: 'Refer', value: 'Refer' },
    { label: 'Oil Tanker', value: 'Oil Tanker' },
    { label: 'Chemical Tanker', value: 'Chemical Tanker' },
    { label: 'Gas Carrier', value: 'Gas Carrier' },
  ];
  segmentOptions: Array<{ label: string; value: string }> = [
    { label: 'Bulk', value: 'Bulk' },
    { label: 'General Cargo', value: 'General Cargo' },
    { label: 'Coaster', value: 'Coaster' },
    { label: 'Coasters', value: 'Coasters' },
    { label: 'Coastal', value: 'Coastal' },
    { label: 'Handysize', value: 'Handysize' },
    { label: 'Handymax', value: 'Handymax' },
    { label: 'Handytankers', value: 'Handytankers' },
    { label: 'Supramax', value: 'Supramax' },
    { label: 'Ultramax', value: 'Ultramax' },
    { label: 'Panamax', value: 'Panamax' },
    { label: 'Kamsarmax', value: 'Kamsarmax' },
    { label: 'Ultra Panamax', value: 'Ultrapanamax' },
    { label: 'Capesize', value: 'Capesize' },
    { label: 'Very Large Ore Carrier (VLOC)', value: 'VLOC' },
    { label: 'Chinamax', value: 'Chinamax' },
    { label: 'Intermediate', value: 'Intermediate' },
    { label: 'MR', value: 'MR' },
    { label: 'LR1 / Panamax', value: 'LR1/Panamax' },
    { label: 'LR2 / Aframax', value: 'LR2/Aframax' },
    { label: 'LR3 / Suezmax', value: 'LR3/Suezmax' },
    { label: 'Suezmax', value: 'Suezmax' },
    { label: 'Aframax', value: 'Aframax' },
    { label: 'LR1', value: 'LR1' },
    { label: 'LR2', value: 'LR2' },
    { label: 'VLCC', value: 'VLCC' },
    { label: 'MGC', value: 'MGC' },
    { label: 'LGC', value: 'LGC' },
    { label: 'VLGC', value: 'VLGC' },
    { label: 'VLEC', value: 'VLEC' }
  ];

  normalizeSegmentValue(segment: any): string {
    if (!segment) return '';
    const raw = String(segment).trim();
    if (!raw) return '';

    // Direct case-insensitive match on value
    const matchVal = this.segmentOptions.find(
      (opt) => opt.value.toLowerCase() === raw.toLowerCase()
    );
    if (matchVal) return matchVal.value;

    // Direct case-insensitive match on label
    const matchLabel = this.segmentOptions.find(
      (opt) => opt.label.toLowerCase() === raw.toLowerCase()
    );
    if (matchLabel) return matchLabel.value;

    // Common abbreviations / aliases normalization
    const cleanKey = raw.toLowerCase().replace(/\s*\/\s*/g, '/').replace(/\s+/g, ' ');
    const aliasMap: Record<string, string> = {
      'suezmax': 'LR3/Suezmax',
      'lr3': 'LR3/Suezmax',
      'lr3/suezmax': 'LR3/Suezmax',
      'aframax': 'LR2/Aframax',
      'lr2': 'LR2/Aframax',
      'lr2/aframax': 'LR2/Aframax',
      'panamax': 'LR1/Panamax',
      'lr1': 'LR1/Panamax',
      'lr1/panamax': 'LR1/Panamax',
      'mr': 'MR',
      'mr2': 'MR',
      'handysize': 'Handysize',
      'handymax': 'Handymax',
      'handytankers': 'Handytankers',
      'ultramax': 'Ultramax',
      'supramax': 'Supramax',
      'kamsarmax': 'Kamsarmax',
      'ultrapanamax': 'Ultrapanamax',
      'ultra panamax': 'Ultrapanamax',
      'capesize': 'Capesize',
      'vloc': 'VLOC',
      'chinamax': 'Chinamax',
      'coaster': 'Coaster',
      'coasters': 'Coasters',
      'coastal': 'Coastal',
      'intermediate': 'Intermediate',
      'vlcc': 'VLCC',
      'mgc': 'MGC',
      'lgc': 'LGC',
      'vlgc': 'VLGC',
      'vlec': 'VLEC',
      'bulk': 'Bulk',
      'general cargo': 'General Cargo',
    };

    if (aliasMap[cleanKey]) {
      const canonical = aliasMap[cleanKey];
      if (!this.segmentOptions.some((opt) => opt.value === canonical)) {
        this.segmentOptions.push({ label: canonical, value: canonical });
      }
      return canonical;
    }

    // Dynamic fallback so an uncommon segment from DB is never rendered blank
    this.segmentOptions.push({ label: raw, value: raw });
    return raw;
  }

  resolveSegment(report: any, data?: any): string {
    const raw =
      report?.vesselSegment ||
      report?.segment ||
      report?.vessel_segment ||
      data?.last_report?.vesselSegment ||
      data?.last_report?.segment ||
      data?.last_report?.vessel_segment ||
      '';
    return this.normalizeSegmentValue(raw);
  }

  timezoneOptions = [
    { label: 'UTC ±00:00', value: '+00:00' },
    { label: '(UTC -12:00)', value: '-12:00' },
    { label: '(UTC -11:00)', value: '-11:00' },
    { label: '(UTC -10:00)', value: '-10:00' },
    { label: '(UTC -09:30)', value: '-09:30' },
    { label: '(UTC -09:00)', value: '-09:00' },
    { label: '(UTC -08:00)', value: '-08:00' },
    { label: '(UTC -07:00)', value: '-07:00' },
    { label: '(UTC -06:00)', value: '-06:00' },
    { label: '(UTC -05:00)', value: '-05:00' },
    { label: '(UTC -04:00)', value: '-04:00' },
    { label: '(UTC -03:30)', value: '-03:30' },
    { label: '(UTC -03:00)', value: '-03:00' },
    { label: '(UTC -02:00)', value: '-02:00' },
    { label: '(UTC -01:00)', value: '-01:00' },
    { label: '(UTC +01:00)', value: '+01:00' },
    { label: '(UTC +02:00)', value: '+02:00' },
    { label: '(UTC +03:00)', value: '+03:00' },
    { label: '(UTC +03:30)', value: '+03:30' },
    { label: '(UTC +04:00)', value: '+04:00' },
    { label: '(UTC +04:30)', value: '+04:30' },
    { label: '(UTC +05:00)', value: '+05:00' },
    { label: '(UTC +05:30)', value: '+05:30' },
    { label: '(UTC +05:45)', value: '+05:45' },
    { label: '(UTC +06:00)', value: '+06:00' },
    { label: '(UTC +06:30)', value: '+06:30' },
    { label: '(UTC +07:00)', value: '+07:00' },
    { label: '(UTC +08:00)', value: '+08:00' },
    { label: '(UTC +08:45)', value: '+08:45' },
    { label: '(UTC +09:00)', value: '+09:00' },
    { label: '(UTC +09:30)', value: '+09:30' },
    { label: '(UTC +10:00)', value: '+10:00' },
    { label: '(UTC +10:30)', value: '+10:30' },
    { label: '(UTC +11:00)', value: '+11:00' },
    { label: '(UTC +12:00)', value: '+12:00' },
    { label: '(UTC +12:45)', value: '+12:45' },
    { label: '(UTC +13:00)', value: '+13:00' },
    { label: '(UTC +14:00)', value: '+14:00' },
  ];

  operationsOptions = [
    { label: 'COSP', value: 'COSP' },
    { label: 'EOSP', value: 'EOSP' },
    { label: 'NOON', value: 'NOON' },

    { label: 'Anchored', value: 'Anchored' },
    { label: 'Anchor Aweigh', value: 'Anchor Aweigh' },
    { label: 'Start drifting', value: 'Start drifting' },
    { label: 'Stop drifting', value: 'Stop drifting' },

    { label: 'Berthed', value: 'Berthed' },
    { label: 'Unberthed', value: 'Unberthed' },

    { label: 'Start Cargo Ops', value: 'Start Cargo Ops' },
    { label: 'Ceased Cargo Ops', value: 'Ceased Cargo Ops' },
    { label: 'Resumed Cargo Ops', value: 'Resumed Cargo Ops' },
    { label: 'End Cargo Ops', value: 'End Cargo Ops' },

    { label: 'EOSP - Start of Ice Edge', value: 'EOSP - Start of Ice Edge' },
    { label: 'COSP - End of Ice Edge', value: 'COSP - End of Ice Edge' },

    { label: 'Berthed - STS', value: 'Berthed - STS' },
    { label: 'Unberthed - STS', value: 'Unberthed - STS' },
  ];

  operationInPortOptions = [
    { label: 'Loading', value: 'loading' },
    { label: 'Discharging', value: 'discharging' },
    { label: 'Transit', value: 'transit' },
    { label: 'Idle', value: 'idle' },
  ];

  slopsTankOptions = [
    { label: 'Slop(p)', value: 'Slop(p)' },
    { label: 'Slop(s)', value: 'Slop(s)' },
    { label: 'ROT', value: 'ROT' },
  ];
  decimalErrors: any = {
    swellDirection: false,
    swellHeightMeter: false,
    seaHeightMeter: false,
  };
  reportTypeOptions = [
    { label: 'At Sea', value: 'atSea' },
    { label: 'In Port', value: 'inPort' },
  ];
  pressureError: boolean = false;
  serverFieldErrors: { [key: string]: string } = {};

  isSubmitting: boolean = false;
  isSubmitted: boolean = false;
  canForceApprove: boolean = false;
  portSuggestions: any = null;

  // @ViewChild('requestformFileInput')

  // requestformFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('requestformFileInput')
  requestformFileInput!: ElementRef<HTMLInputElement>;

  @ViewChild('voyageDrawer')
  voyageDrawer!: MatDrawer;
  voyageHeaders: { key: string; label: string }[] = [];
  voyageRows: any[] = [];
  isVoyageLoading = false;
  alreadySubmitted: boolean = false;
  isAtSea = false;
  isInPort = false;
  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private requestFormService: RequestFormService,
    private pRequestFormService: PortRequestFormServiceService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private portMailService: PortMailService,
  ) {
    this.requestForm = this.fb.group({
      json_report_id: [''],
      erTemp: [''],
      scavengeAirPress: [''],
      scavengeAirTemp: [''],
      airCoolerTemp: [''],
      vesselName: ['', Validators.required],
      imoNumber: ['', Validators.required],
      vesselSegment: ['', Validators.required],
      vesselType: ['', Validators.required],
      vesselCondition: ['', Validators.required],
      voyageNumber: [''],
      canEditMerakiVoyage: [false],
      endOfLeg: [false],
      merakiVoyageNumber: [{ value: '', disabled: true }],
      departurePort: ['', Validators.required],
      destinationPort: [''],

      reportType: ['', Validators.required],
      reportDate: ['', Validators.required],
      reportHour: ['', Validators.required],
      reportMinute: ['', Validators.required],
      portTimeZone: ['', Validators.required],

      eventsList: ['', Validators.required],
      operationInPort: [''],

      etaOrderDate: [''],
      etaOrderHour: [''],
      etaOrderMinute: [''],

      etaWeatherDate: [''],
      etaWeatherHour: [''],
      etaWeatherMinute: [''],
      etaWeatherLthour: [''],
      etaWeatherLtminute: [''],

      chartererName: [''],

      forwardDraftValue: [''],
      afterDraftValue: [''],
      displacementValue: [''],
      slopsRob: [''],
      slopsTank: [''],

      latitudeDegree: [''],
      latitudeMin: [''],
      latitudeDir: [''],
      latitudeResult: [''],

      longitudeDegree: [''],
      longitudeMin: [''],
      longitudeDir: [''],
      longitudeResult: [''],

      remainingDistance: [''],
      steamingDistanceGps: [''],
      steamingHoursReport: [''],
      avgSpeedReport: [''],
      logDistanceReport: [''],
      logSpeedReport: [''],
      avgCourseReport: [''],
      totalDistanceGps: [''],
      totalVoyageHours: [''],
      overallAverageSpeed: [''],
      engineLogDistance: [''],
      slipPercentage: [''],

      mainEngineRpm: [''],
      engineAverageBhp: [''],
      meRevolutionCounter: [''],
      engineSpeed: [''],
      engineLoadPercent: [''],
      meRunningHours: [''],

      trueWindDirection: [''],
      trueWindKnots: [''],
      windForceBf: [''],
      windDescriptionSelect: [''],
      relativeWindSpeedKnots: [''],
      relativeWindDirectionDegrees: [''],
      swellDirection: [''],
      swellHeightMeter: [''],
      seaHeightMeter: [''],
      trueSeaDirection: [''],
      currentDirectionSelect: [''],
      currentKnots: [''],
      airTemperature: [''],
      seaTemperature: [''],
      pressureMbar: [''],

      freshWaterRob: [''],
      distilledWaterQty: [''],

      reeferCount: [''],
      reeferKwh: [''],

      voyageRemarks: [''],

      mgoMeConsumption: [''],
      mgoAeConsumption: [''],
      mgoBlrConsumption: [''],
      mgoOthersConsumptionType: [''],
      mgoOthersConsumptionQuantity: [''],
      mgoTotalConsumption: [''],
      mgoBunkerRob: [''],

      gasOilPowerPack: [''],
      incineratorGasOil: [''],
      inertingGasOil: [''],

      mgoMeOldRob: [''],
      mgoAeOldRob: [''],
      mgoBlrOldRob: [''],
      mgoTotalOldRob: [''],
      lngTotalOldRob: [''],

      bunkerGrade1: [''],
      quantity1: [''],
      descrepency1: [''],

      bunkerGrade2: [''],
      quantity2: [''],
      descrepency2: [''],

      bunkerGrade3: [''],
      quantity3: [''],
      descrepency3: [''],

      contractualSpeed: [''],
      contractualConsumpFo: [''],
      contractualConsumpGo: [''],

      auxEngineOneHours: [''],
      auxEngineOneKw: [''],
      auxEngineTwoHours: [''],
      auxEngineTwoKw: [''],
      auxEngineThreeHours: [''],
      auxEngineThreeKw: [''],

      cargoDetails: this.fb.array([]),
      fuelOilData: this.fb.array([]),

      aeConsumptionSinceLastReport: [''],
      blrConsumptionSinceLastReport: [''],
      bunkerGrades: [''],
      distilledWaterQuantityMt: [''],
      meConsumptionSinceLastReport: [''],
      meRunningHoursSinceLastReport: [''],
      mgoBunkerOldRob: [''],
      mgoOldRobDate: [''],
      mgoOldRobHour: [''],
      mgoOldRobMinute: [''],
      mgoOthersOldRobQuantity: [''],
      mgoOthersOldRobQuantityError: [''],
      mgoOthersOldRobType: [''],
      mgoReportDate: [''],
      mgoReportHour: [''],
      mgoReportMinute: [''],
      operations: [''],
      report_timestamp: [''],
      seaStatus: [''],
      // v2.4 fields
      copOneRpm: [''],
      copTwoRpm: [''],
      copThreeRpm: [''],
      hydraulicSysPressure: [''],
      formRevision: [1],
      revisionChain: [[]],
      finalSubmitTimeUTC: [''],
      totalShaftPower: [''],
      driftingDistance: [''],
      etdCurrentPortDate: [''],

    });
  }

  ngOnInit(): void {
    this.requestForm.get('reportType')?.valueChanges.subscribe(() => {
      this.applyReportTypeLogic();
    });
    this.pRequestFormService.reportData$
      .pipe(
        filter((data) => !!data), // Ignore null/cleared emissions
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        if (data?.report) {
          setTimeout(() => {
            this.autoPopulateForm(data.report, data);
            this.portSuggestions = data.portSuggestions || null;
            this.isUpload = true;
            this.alreadySubmitted = data.report.submitted;
            const fieldErrors = data.report?.errors?.fieldErrors || {};
            if (Object.keys(fieldErrors).length > 0) {
              this.errorAvailable = true;
              this.applyServerErrorsTSOnly(data.report);
            }

            this.requestForm.updateValueAndValidity();
            this.pRequestFormService.clearReportData();
          });
        }
        if (data?.last_report) {
          this.lastReport = data.last_report;
        }
      });

    this.route.queryParams.subscribe((params) => {
      const imo = params['imo'];
      const jsonReportId = params['json_report_id'];

      if (imo && jsonReportId) {
        this.pRequestFormService
          .getPendingReports(imo, jsonReportId)
          .subscribe({
            next: (res: any) => {
              if (res) {
                this.portSuggestions = res.portSuggestions || null;
                let data = {
                  prevMerakiVoyageNumber: res.prevMerakiVoyageNumber,
                  canEditMerakiVoyage: res.canEditMerakiVoyage,
                  last_report: res.last_report,
                };
                this.autoPopulateForm(res.report, data);
                this.isUpload = true;
                this.errorMailDrafted = !!res.report?.error_mail_drafted;
                this.errorMailDraftedAt = res.report?.error_mail_drafted_at || null;
                const fieldErrors = res.report?.errors?.fieldErrors || {};
                if (Object.keys(fieldErrors).length > 0) {
                  this.errorAvailable = true;
                  this.applyServerErrorsTSOnly(res.report);
                }
              }
            },
            error: (err) => {
              this.toastr.error('Failed to load report data');
              console.error(err);
            },
          });
      }
    });
    this.addFuelOilRow();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  applyReportTypeLogic() {
    const report = this.requestForm.get('reportType')?.value;

    this.isAtSea = report === 'atSea';
    this.isInPort = report === 'inPort';

    const operationControl = this.requestForm.get('operationInPort');

    if (this.isAtSea) {
      operationControl?.setValue('');
      operationControl?.disable();
    }
    else if (this.isInPort) {
      operationControl?.enable();
    }
  }
  // openRetrievePopup(): void {
  //   const dialogRef = this.dialog.open(RetriveReportsFetchComponent, {
  //     width: '900px',
  //     maxWidth: '95vw',
  //     maxHeight: '90vh',
  //     disableClose: true,
  //   });

  //   dialogRef.afterClosed().subscribe((result: any) => {
  //     if (result) {
  //       console.log('Retrieve popup result:', result);
  //     }
  //   });
  // }
  goToDashboardReporting() {
    this.router.navigate(['/ms-vesselSummary']);
  }
  openVoyageDrawer() {
    const imo = this.requestForm.get('imoNumber')?.value;

    if (!imo) {
      this.toastr.error('IMO Number missing');
      return;
    }

    this.isVoyageLoading = true;

    this.pRequestFormService.getLastVoyageData(imo).subscribe({
      next: (res: any) => {
        this.isVoyageLoading = false;

        this.voyageHeaders = res?.headers || [];

        this.voyageRows = res?.rows || [];

        this.voyageDrawer.open();
      },
      error: () => {
        this.isVoyageLoading = false;
        this.toastr.error('Failed to load voyage data');
      },
    });
  }

  openMerakiPopup(event: any) {
    if (event.target.checked) {
      this.openMerakiVoyageModal(); // open popup
    }
  }

  openMerakiVoyageModal() {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      width: '600px',
      panelClass: 'meraki-popup',
    });

    dialogRef.afterClosed().subscribe((selectedVoyage: any) => {
      if (!selectedVoyage) {
        this.requestForm.patchValue({ endOfLeg: false });
      } else {
        this.requestForm.patchValue({ endOfLeg: true });
      }
    });
  }

  clearClick(skipToast: boolean = false) {
    this.clearServerErrorsTSOnly();

    this.formSubmitted = false;
    this.isUpload = false;
    this.pressureError = false;
    this.errorMailDrafted = false;
    this.errorMailDraftedAt = null;
    this.isLoadingDraftPreview = false;
    this.lastValidationErrors = null;
    this.requestForm.reset();
    this.requestForm.markAsPristine();
    this.requestForm.markAsUntouched();
    this.requestForm.updateValueAndValidity({ emitEvent: false });

    this.cargoDetails.clear();
    this.fuelOilData.clear();

    this.addCargoRow();
    this.addFuelOilRow();
    if (this.requestformFileInput?.nativeElement) {
      this.requestformFileInput.nativeElement.value = '';
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });

    if (!skipToast) {
      this.toastr.success('Form cleared successfully!');
    }
  }

  submitClick() {
    this.clearServerErrorsTSOnly();
    const payload = {
      json_report_id: this.requestForm.get('json_report_id')?.value,
      vesselIMO: this.requestForm.get('imoNumber')?.value,
    };

    if (!payload.json_report_id) {
      this.toastr.error('json_report_id missing!');
      return;
    }

    if (!payload.vesselIMO) {
      this.toastr.error('IMO Number missing!');
      return;
    }

    this.pRequestFormService.submitJsonReport(payload).subscribe({
      next: (res: any) => {
        this.toastr.success('Report Submitted Successfully!');
      },
      error: (err: any) => {
        this.toastr.error(err.error.error);
      },
    });
  }
  backToRequestForm() {
    this.router.navigate(['/pc-data-qualitycheck']);
  }
  downloadExcel() {
    const link = document.createElement('a');
    link.href = 'assets/sample.xlsx';
    link.download = 'RequestForm.xlsx';
    link.click();
  }

  openForceApproveModal() {
    if (this.isSubmitting || !this.canForceApprove) return;

    const dialogRef = this.dialog.open(ForceApprovePopupComponent, {
      width: '520px',
      maxWidth: '95vw',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((analystReport: string | null) => {
      if (!analystReport) return;
      this.verifyReport(analystReport, true);
    });
  }

  downloadErrorExcel() {
    this.isSubmitting = true
    if (!this.errorAvailable) return;

    const payload = this.requestForm.getRawValue();
    const id = payload.json_report_id || this.requestForm.get('json_report_id')?.value;

    if (!id) {
      this.isSubmitting = false
      this.toastr.error('Report ID missing!');
      return;
    }

    this.pRequestFormService.downloadErrorExcel(id).subscribe({
      next: (res: any) => {
        if (res?.success === true && res?.url) {
          this.isSubmitting = false
          window.open(res.url, '_blank');
        } else {
          this.isSubmitting = false
          this.toastr.error(res?.message || 'Download Failed!');
        }
      },
      error: (err: any) => {
        this.isSubmitting = false
        const apiRes = err?.error || err;
        this.toastr.error(apiRes?.message || apiRes?.error || 'Download Failed!');
      },
    });
  }

  // verifyReport(analystReport?: string, forceSubmit: boolean = false) {
  //   this.formSubmitted = true;
  //   this.requestForm.markAllAsTouched();

  //   this.clearServerErrorsTSOnly();

  //   const payload = this.requestForm.getRawValue();

  //   payload.json_report_id =
  //     payload.json_report_id || this.requestForm.get('json_report_id')?.value;

  //   payload.vesselIMO = payload.imoNumber;

  //   if (analystReport) {
  //     payload.analyst_report = analystReport;
  //   }
  //   this.isSubmitting = true;

  //   this.pRequestFormService.verifyMasterReport(payload, forceSubmit).subscribe({
  //     next: (res: any) => {
  //       this.isSubmitting = false;
  //       if (res?.success === false) {
  //         this.toastr.error(res?.message || 'Validation errors');
  //         this.applyServerErrorsTSOnly(res);
  //         this.canForceApprove = true;
  //         return;
  //       }
  //       this.toastr.success(res?.message || 'Report Verified Successfully!');
  //       this.router.navigate(['/ms-requestForm']);
  //     },

  //     error: (err: any) => {
  //       this.isSubmitting = false;
  //       const apiRes = err?.error || err;
  //       this.toastr.error(apiRes?.message || apiRes?.error || 'Verify Failed!');
  //       this.errorAvailable = true;
  //       this.applyServerErrorsTSOnly(apiRes);
  //       this.canForceApprove = true;
  //     },
  //   });
  // }
  verifyReport(analystReport?: string, forceSubmit: boolean = false) {
    this.clearServerErrorsTSOnly();
    const payload = this.requestForm.getRawValue();
    payload.vesselIMO = payload.imoNumber;
    if (forceSubmit) {
      payload.analystReport = analystReport
      payload.analyst_report = analystReport
    }

    this.pRequestFormService.verifyMasterReport(payload, forceSubmit).subscribe({

      next: (res: any) => {

        // Success case
        if (res?.success) {
          this.toastr.success(res?.message || 'Report Verified Successfully!');

          // EOSP / COSP of an EmzOil or Elite tanker: offer the port call mail first.
          this.offerPortMail(payload.json_report_id, payload.eventsList).then(() => {
            // If Force Ingested with validation errors and email not drafted yet, prompt to draft discrepancy email
            if (forceSubmit && this.errorAvailable && !this.errorMailDrafted && this.canDraftEmail) {
              const confirmDialog = this.dialog.open(ConfirmPopupComponent, {
                width: '460px',
                disableClose: true,
                panelClass: 'custom-dialog-container',
                data: {
                  mainTitle: 'Force Ingested with Discrepancies',
                  title: 'This report has validation errors. Would you like to draft and send the discrepancy email to the vessel now?',
                  yesText: 'Draft Email',
                  noText: 'Skip for Now',
                  iconClass: 'fa-solid fa-envelope-open-text',
                  isSuccess: false
                }
              });

              confirmDialog.afterClosed().subscribe((draftConfirmed) => {
                if (draftConfirmed) {
                  this.viewDraftEmail();
                } else {
                  this.openAfterApproveDialog();
                }
              });
            } else {
              this.openAfterApproveDialog();
            }
          });
        }

      },

      error: (err: any) => {

        this.isSubmitting = false;
        const apiRes = err?.error || err;

        if (!apiRes?.is_warning) {
          this.errorAvailable = true;
          this.applyServerErrorsTSOnly(apiRes);
          this.canForceApprove = true;
        } else if (apiRes?.is_warning) {
          const warnings = Object.values(
            apiRes?.errors?.fieldWarnings || {}
          );
          const dialogRef = this.dialog.open(AproveErrorpopupComponent, {
            width: '500px',
            disableClose: true,
            data: { warnings }
          });
          dialogRef.afterClosed().subscribe(result => {

            if (result === 'proceed') {

              const payload = this.requestForm.getRawValue();
              payload.vesselIMO = payload.imoNumber;
              if (forceSubmit) {
                payload.analystReport = analystReport;
                payload.analyst_report = analystReport
              }

              this.pRequestFormService
                .verifyMasterReportIgnoreWarning(payload, forceSubmit)
                .subscribe((res: any) => {

                  this.toastr.success(res?.message || 'Report Verified Successfully!');
                  this.offerPortMail(payload.json_report_id, payload.eventsList).then(() => this.openAfterApproveDialog());

                });

            }

          });

          return;
        }

        this.toastr.error(apiRes?.message || 'Verify Failed!');
      }

    });

  }

  /** EOSP / COSP reports can carry a port call mail to the Master (EmzOil and Elite tankers). */
  get isPortMailEvent(): boolean {
    const event = String(this.requestForm.get('eventsList')?.value || '').trim().toUpperCase();
    return event === 'EOSP' || event === 'COSP';
  }

  /** After Approve: ask whether to draft the port call mail; resolves once that is done or declined. */
  private async offerPortMail(reportId: any, event: any): Promise<void> {
    const ev = String(event || '').trim().toUpperCase();
    if (!this.canDraftEmail || !reportId || (ev !== 'EOSP' && ev !== 'COSP')) return;
    await this.portMailService.runFlow(this.dialog, this.toastr, reportId, 'approval');
  }

  /** "Port Mail" button: draft the port call mail for the loaded EOSP / COSP report by hand. */
  async openPortMail(): Promise<void> {
    const reportId = this.requestForm.get('json_report_id')?.value;
    if (!reportId) {
      this.toastr.warning('Please load an EOSP or COSP report first.');
      return;
    }
    if (this.isLoadingPortMail) return;
    this.isLoadingPortMail = true;
    try {
      await this.portMailService.runFlow(this.dialog, this.toastr, reportId, 'manual');
    } finally {
      this.isLoadingPortMail = false;
    }
  }

  isLoadingPortMail = false;

  openAfterApproveDialog(mainTitle: string = 'Report Verified!', title: string = 'Do you want to approve the next report?') {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      width: '450px',
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: {
        mainTitle: mainTitle,
        title: title,
        yesText: 'Approve Next',
        noText: 'Exit to Reports',
        iconClass: 'fa-solid fa-check-circle',
        isSuccess: true
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.viewReport();
      } else {
        this.router.navigate(['/pc-data-qualitycheck']);
      }
    });
  }

  viewReport(): void {
    const dialogRef = this.dialog.open(ReportVerifyPopupComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Popup closed. Result:', result);
      if (!result) {
        this.router.navigate(['/pc-data-qualitycheck']);
      }
    });
  }
  isDraftingEmail: boolean = false;
  isLoadingDraftPreview: boolean = false;
  errorMailDrafted: boolean = false;
  errorMailDraftedAt: string | null = null;
  lastValidationErrors: any = null;

  /**
   * Sequence errors of an earlier report that is already verified (e.g. Unberthed force ingested
   * without a Berthed) are not raised again on later reports; say which ones were left out.
   */
  private noteCarriedErrors(carried: any[] | undefined) {
    if (!carried?.length) return;
    const esc = (v: any) => String(v ?? '').replace(/[&<>"']/g, (ch) => `&#${ch.charCodeAt(0)};`);
    const lines = carried.map((c) => `${esc(c.event || 'Earlier report')}: ${esc(c.message || c.reason)}`);
    this.toastr.info(
      `${lines.join('<br>')}<br><small>Raised on an earlier verified report, so not counted or mailed again.</small>`,
      `${carried.length} earlier sequence error${carried.length === 1 ? '' : 's'} not repeated`,
      { enableHtml: true, timeOut: 9000 },
    );
  }

  clearServerErrorsTSOnly() {
    document.querySelectorAll('.server-error-msg').forEach((el) => el.remove());
    document.querySelectorAll('.ignore-error-btn').forEach((el) => el.remove());
    document.querySelectorAll('.server-error-framed-container').forEach((el) => {
      el.classList.remove('server-error-framed-container');
    });

    document.querySelectorAll('[formControlName]').forEach((el: any) => {
      el.style.border = '';
      el.classList.remove('server-error-border');
    });

    Object.keys(this.requestForm.controls).forEach((key) => {
      const ctrl = this.requestForm.get(key);
      if (!ctrl) return;

      if (ctrl.errors?.['serverError']) {
        const errors = { ...(ctrl.errors || {}) };
        delete errors['serverError'];
        ctrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    });
  }

  applyServerErrorsTSOnly(apiRes: any) {
    this.lastValidationErrors = apiRes?.errors || null;
    this.noteCarriedErrors(apiRes?.errors?.carriedErrors);
    const fieldErrors = apiRes?.errors?.fieldErrors;
    if (!fieldErrors) return;

    Object.keys(fieldErrors).forEach((fieldKey: string) => {
      const message = fieldErrors[fieldKey]?.message || 'Invalid value';

      const ctrl = this.requestForm.get(fieldKey);
      if (ctrl) {
        ctrl.setErrors({ ...(ctrl.errors || {}), serverError: true });
        ctrl.markAsTouched();
      }

      const el = document.querySelector(
        `[formControlName="${fieldKey}"]`,
      ) as HTMLElement;

      if (!el) return;

      el.classList.add('server-error-border');

      // Frame ONLY the immediate field column container (e.g. .col-md-2, .col-md-3, .col-md-4, .col-md-6)
      // Do NOT match outer wrappers like .col-md-8 or .textBox which wrap multiple distinct fields
      const parentCol = (el.closest('.col-md-2, .col-md-3, .col-md-4, .col-md-6, .col-12, .col-lg-3, .col-lg-4') ||
        el.parentElement) as HTMLElement;
      let frame: HTMLElement | null = null;
      if (parentCol && !parentCol.classList.contains('textBox') && !parentCol.classList.contains('row')) {
        frame = parentCol;
      } else if (el.parentElement) {
        frame = el.parentElement;
      }
      if (frame) {
        frame.classList.add('server-error-framed-container');
        if (fieldErrors[fieldKey]?.ignorable !== false) {
          this.addIgnoreErrorButton(frame, fieldKey, fieldErrors[fieldKey]);
        }
      }

      const nextEl = el.nextElementSibling as HTMLElement;
      if (nextEl && nextEl.classList.contains('server-error-msg')) {
        nextEl.remove();
      }

      const small = document.createElement('small');
      small.className = 'server-error-msg';
      small.innerText = message;

      el.insertAdjacentElement('afterend', small);
    });
  }

  /** "Ignore Error" icon on the right of a red error box; opens the reason/attachments popup. */
  private addIgnoreErrorButton(frame: HTMLElement, fieldKey: string, error: any) {
    if (!this.canDraftEmail) return;
    frame.querySelectorAll('.ignore-error-btn').forEach((b) => b.remove());
    if (getComputedStyle(frame).position === 'static') {
      frame.style.position = 'relative';
    }
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ignore-error-btn';
    btn.title = 'Ignore Error';
    btn.setAttribute('aria-label', 'Ignore Error');
    btn.innerHTML = '<i class="fa-solid fa-eye-slash"></i>';
    Object.assign(btn.style, {
      position: 'absolute', top: '6px', right: '8px', width: '26px', height: '26px',
      border: '1px solid #ef4444', borderRadius: '50%', background: '#ffffff', color: '#dc2626',
      display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
      fontSize: '12px', padding: '0', zIndex: '2',
    });
    btn.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      this.openIgnoreErrorPopup(fieldKey, error);
    });
    frame.appendChild(btn);
  }

  openIgnoreErrorPopup(fieldKey: string, error: any) {
    const reportId = this.requestForm.get('json_report_id')?.value;
    if (!reportId) {
      this.toastr.warning('Please select a report first.');
      return;
    }
    const label = error?.label || this.formatFieldLabel(fieldKey);
    const dialogRef = this.dialog.open(IgnoreErrorPopupComponent, {
      width: '520px',
      maxWidth: '95vw',
      disableClose: true,
      data: { reportId, fieldKey, label, message: error?.message || '', error: { ...(error || {}), key: fieldKey } },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;
      this.removeIgnoredError(fieldKey);
      this.toastr.success(`${label} ignored. It will not be mailed or counted.`);
    });
  }

  /** Clears one ignored error from the page; the report's other errors stay as they are. */
  private removeIgnoredError(fieldKey: string) {
    const fieldErrors = this.lastValidationErrors?.fieldErrors;
    if (fieldErrors) {
      delete fieldErrors[fieldKey];
    }
    const ctrl = this.requestForm.get(fieldKey);
    if (ctrl?.errors?.['serverError']) {
      const errors = { ...(ctrl.errors || {}) };
      delete errors['serverError'];
      ctrl.setErrors(Object.keys(errors).length ? errors : null);
    }
    const el = document.querySelector(`[formControlName="${fieldKey}"]`) as HTMLElement | null;
    if (!el) return;
    el.classList.remove('server-error-border');
    const next = el.nextElementSibling as HTMLElement | null;
    if (next?.classList.contains('server-error-msg')) next.remove();
    const frame = el.closest('.server-error-framed-container') as HTMLElement | null;
    if (frame) {
      frame.classList.remove('server-error-framed-container');
      frame.querySelectorAll('.ignore-error-btn').forEach((b) => b.remove());
    }
  }

  getFieldSection(fieldKey: string): string {
    const key = (fieldKey || '').toLowerCase();
    if (key.includes('segment') || key.includes('condition') || key.includes('vesseltype') || key.includes('seastatus') || key.includes('operation')) {
      return 'Vessel Particulars';
    }
    if (key.includes('voyage') || key.includes('port') || key.includes('eta') || key.includes('etd') || key.includes('timezone')) {
      return 'Voyage Details';
    }
    if (key.includes('lat') || key.includes('long') || key.includes('speed') || key.includes('course') || key.includes('distance') || key.includes('steaming')) {
      return 'Navigation & Position';
    }
    if (key.includes('wind') || key.includes('sea') || key.includes('swell') || key.includes('temp') || key.includes('pressure') || key.includes('current')) {
      return 'Weather & Sea';
    }
    if (key.includes('engine') || key.includes('rpm') || key.includes('bhp') || key.includes('load') || key.includes('cop') || key.includes('slip') || key.includes('shaft')) {
      return 'Engine & Propulsion';
    }
    if (key.includes('rob') || key.includes('consump') || key.includes('mgo') || key.includes('hsfo') || key.includes('vlsfo') || key.includes('slop') || key.includes('water')) {
      return 'Bunkers';
    }
    if (key.includes('draft') || key.includes('cargo') || key.includes('displace') || key.includes('charterer')) {
      return 'Cargo & Drafts';
    }
    return 'Report Details';
  }

  formatFieldLabel(fieldKey: string): string {
    if (!fieldKey) return 'Field';
    return fieldKey
      .replace(/([A-Z])/g, ' $1')
      .replace(/[_\-]+/g, ' ')
      .trim()
      .replace(/^./, str => str.toUpperCase());
  }

  async renderAestheticFieldCard(
    fieldKey: string,
    labelText: string,
    reportedVal: string,
    errorMsg: string,
    expectedVal?: string
  ): Promise<string> {
    try {
      const scale = 1.2;
      const w = 480;
      const h = 180;

      const canvas = document.createElement('canvas');
      canvas.width = Math.round(w * scale);
      canvas.height = Math.round(h * scale);
      const ctx = canvas.getContext('2d');
      if (!ctx) return '';

      ctx.scale(scale, scale);

      // Helper for rounded rectangle paths
      const drawRoundRect = (x: number, y: number, rw: number, rh: number, r: number) => {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.lineTo(x + rw - r, y);
        ctx.quadraticCurveTo(x + rw, y, x + rw, y + r);
        ctx.lineTo(x + rw, y + rh - r);
        ctx.quadraticCurveTo(x + rw, y + rh, x + rw - r, y + rh);
        ctx.lineTo(x + r, y + rh);
        ctx.quadraticCurveTo(x, y + rh, x, y + rh - r);
        ctx.lineTo(x, y + r);
        ctx.quadraticCurveTo(x, y, x + r, y);
        ctx.closePath();
      };

      // 1. Outer wrapper background (#EEF1F5)
      drawRoundRect(0, 0, w, h, 16);
      ctx.fillStyle = '#EEF1F5';
      ctx.fill();

      // 2. Inner card background (#FFFFFF) with #FCA5A5 border
      drawRoundRect(20, 16, w - 40, h - 32, 14);
      ctx.fillStyle = '#FFFFFF';
      ctx.fill();
      ctx.lineWidth = 2;
      ctx.strokeStyle = '#FCA5A5';
      ctx.stroke();

      // 3. Label text + red asterisk
      ctx.font = 'bold 20px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.fillStyle = '#111827';
      ctx.textBaseline = 'top';
      ctx.fillText(labelText, 42, 34);
      const labelWidth = ctx.measureText(labelText).width;

      ctx.font = 'bold 22px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.fillStyle = '#EF4444';
      ctx.fillText('*', 42 + labelWidth + 4, 32);

      // 4. Input pill / box
      const isSelect = !reportedVal || reportedVal === 'Select' || reportedVal.toLowerCase().includes('select') || reportedVal.toLowerCase().includes('not reported');
      let displayVal = reportedVal || 'Select';
      if (isSelect) {
        displayVal = 'Select';
      } else if (!displayVal.startsWith('>') && !displayVal.startsWith('Not')) {
        displayVal = `> ${displayVal}`;
      }

      const pillRadius = isSelect ? 10 : 21;
      drawRoundRect(42, 68, w - 84, 42, pillRadius);
      ctx.fillStyle = '#FFFFFF';
      ctx.fill();
      ctx.lineWidth = 1.5;
      ctx.strokeStyle = '#F87171';
      ctx.stroke();

      ctx.font = '500 15px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.fillStyle = isSelect ? '#6B7280' : '#111827';
      ctx.textBaseline = 'middle';
      ctx.fillText(displayVal, 56, 89);

      // 5. Red error message underneath (full wrapped text)
      ctx.font = '400 13.5px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
      ctx.fillStyle = '#DC2626';
      ctx.textBaseline = 'top';
      const cleanErr = (errorMsg || 'Validation error').replace(/\s+/g, ' ').trim();
      const maxTextWidth = w - 88;
      const words = cleanErr.split(' ');
      const errLines: string[] = [];
      let currentLine = '';
      for (const word of words) {
        const testLine = currentLine ? `${currentLine} ${word}` : word;
        if (ctx.measureText(testLine).width > maxTextWidth && currentLine) {
          errLines.push(currentLine);
          currentLine = word;
        } else {
          currentLine = testLine;
        }
      }
      if (currentLine) {
        errLines.push(currentLine);
      }
      errLines.forEach((line, i) => {
        ctx.fillText(line, 44, 118 + i * 16);
      });

      return canvas.toDataURL('image/png', 0.98);
    } catch (err) {
      console.error('Canvas card rendering failed:', err);
      return '';
    }
  }

  async captureErrorScreenshots(): Promise<{
    fieldKey: string;
    field: string;
    label: string;
    section: string;
    errorMsg: string;
    reported: string;
    expected: string;
    dataUrl: string;
  }[]> {
    const issues: {
      fieldKey: string;
      field: string;
      label: string;
      section: string;
      errorMsg: string;
      reported: string;
      expected: string;
      dataUrl: string;
    }[] = [];

    const fieldErrors = this.lastValidationErrors?.fieldErrors || {};
    const fieldKeys = Object.keys(fieldErrors);

    if (fieldKeys.length > 0) {
      for (const key of fieldKeys) {
        try {
          const errInfo = fieldErrors[key] || {};
          const errorMsg = (errInfo.message || 'Validation failed').trim();

          // Form control element
          const inputEl = document.querySelector(`[formControlName="${key}"]`) as HTMLInputElement | HTMLSelectElement | null;

          // Determine Label
          let labelText = errInfo.label;
          if (!labelText && inputEl) {
            const parentContainer = inputEl.closest('.col-md-2, .col-md-3, .col-md-4, .col-md-6, .col-12, .col-lg-3, .col-lg-4, .form-group');
            const labelEl = parentContainer?.querySelector('label, .TextLabel');
            labelText = labelEl ? (labelEl.textContent || '').replace('*', '').trim() : '';
          }
          if (!labelText) {
            labelText = this.formatFieldLabel(key);
          }

          // Section
          const section = this.getFieldSection(key);

          // Reported and Expected values
          let reportedVal = errInfo.inputtedValue !== undefined && errInfo.inputtedValue !== null
            ? String(errInfo.inputtedValue)
            : String(this.requestForm.get(key)?.value ?? '');
          if (!reportedVal || reportedVal === 'null' || reportedVal === 'undefined') {
            reportedVal = 'Not reported / Select';
          }

          let expectedVal = errInfo.expected || '';
          if (!expectedVal) {
            const expMatch = errorMsg.match(/Expected\s+['"]?([^'"]+)['"]?/i);
            if (expMatch) {
              expectedVal = expMatch[1];
            }
          }

          // Render pristine isolated aesthetic card screenshot
          const dataUrl = await this.renderAestheticFieldCard(
            key,
            labelText,
            reportedVal,
            errorMsg,
            expectedVal
          );

          issues.push({
            fieldKey: key,
            field: key,
            label: labelText,
            section: section,
            errorMsg: errorMsg,
            reported: reportedVal,
            expected: expectedVal,
            dataUrl: dataUrl
          });
        } catch (cardErr) {
          console.error(`Failed to capture aesthetic screenshot for field ${key}:`, cardErr);
        }
      }
    } else {
      // Fallback: If no lastValidationErrors dict, inspect DOM elements with server-error-border
      const borderEls = Array.from(document.querySelectorAll('.server-error-border')) as HTMLElement[];
      for (let i = 0; i < borderEls.length; i++) {
        const el = borderEls[i];
        const key = el.getAttribute('formControlName') || `field_${i + 1}`;
        const parentContainer = el.closest('.col-md-2, .col-md-3, .col-md-4, .col-md-6, .col-12, .col-lg-3, .col-lg-4, .form-group');
        const labelEl = parentContainer?.querySelector('label, .TextLabel');
        const labelText = labelEl ? (labelEl.textContent || '').replace('*', '').trim() : this.formatFieldLabel(key);
        const errEl = parentContainer?.querySelector('.server-error-msg') || el.nextElementSibling;
        const errorMsg = (errEl?.textContent || 'Validation error').trim();
        const reportedVal = String(this.requestForm.get(key)?.value || 'Select');
        const dataUrl = await this.renderAestheticFieldCard(key, labelText, reportedVal, errorMsg);

        issues.push({
          fieldKey: key,
          field: key,
          label: labelText,
          section: this.getFieldSection(key),
          errorMsg: errorMsg,
          reported: reportedVal,
          expected: '',
          dataUrl: dataUrl
        });
      }
    }

    return issues;
  }

  /** Drafting correction emails is limited to Meraki administrators. */
  readonly canDraftEmail = isMerakiAdminUser();

  async draftErrorEmail(customOverrides?: { to?: string; cc?: string; subject?: string; html?: string; issues?: any[]; comment?: string; unselected_keys?: string[] }) {
    if (!this.canDraftEmail) {
      this.toastr.warning('Drafting correction emails is restricted to Meraki administrators.', 'Access Restricted');
      return;
    }
    if (this.isDraftingEmail) return;

    const payload = this.requestForm.getRawValue();
    const reportId = payload.json_report_id || this.requestForm.get('json_report_id')?.value;
    const vesselName = payload.vesselName || this.requestForm.get('vesselName')?.value || 'Vessel';
    const vesselIMO = payload.imoNumber || this.requestForm.get('imoNumber')?.value || 'N/A';
    const reportDate = payload.reportDate || 'N/A';
    const voyageNumber = payload.voyageNumber || 'N/A';
    const eventsList = payload.eventsList || 'N/A';

    if (!reportId) {
      this.toastr.warning('Please select a report first before drafting an error mail.');
      return;
    }

    this.isDraftingEmail = true;
    this.toastr.info('Generating high-resolution discrepancy cards & preparing Sage Letter draft...', 'Processing');

    try {
      // 1. Capture pristine aesthetic screenshots of erroneous inputs (or use pre-captured issues)
      let issues = customOverrides?.issues;
      if (!issues || issues.length === 0) {
        issues = await this.captureErrorScreenshots();
      }

      const auditPayload: any = {
        id: reportId,
        to_email: customOverrides?.to || payload.sourceEmail || this.requestForm.get('sourceEmail')?.value || '',
        cc_email: customOverrides?.cc || 'operations@merakishippingservices.com',
        vesselName: vesselName,
        vesselIMO: vesselIMO,
        eventsList: eventsList,
        reportDate: reportDate,
        reportHour: payload.reportHour,
        reportMinute: payload.reportMinute,
        issues: issues,
        errorCount: issues.length,
        errorsSummary: issues.map((c: any) => ({ label: c.label, error: c.errorMsg || c.message, key: c.fieldKey || c.field })),
        unselected_keys: customOverrides?.unselected_keys || [],
        screenshotsCount: issues.length,
        notes: `Sage Letter correction email drafted into reports@merakishippingservices.com Drafts`,
        rawReport: payload
      };

      if (customOverrides?.subject) {
        auditPayload.subject = customOverrides.subject;
      }
      if (customOverrides?.html) {
        auditPayload.html = customOverrides.html;
        auditPayload.custom_html = customOverrides.html;
      }
      if (customOverrides?.comment) {
        auditPayload.comment = customOverrides.comment;
      }

      // 2. Draft into reports@merakishippingservices.com mailbox & audit record
      this.pRequestFormService.recordErrorEmail(auditPayload).subscribe({
        next: (res: any) => {
          this.errorMailDrafted = true;
          this.errorMailDraftedAt = new Date().toISOString();
          const reminder = res?.reminder || 1;
          const resolved = res?.resolved_count || 0;
          const newlyAdded = res?.new_count || 0;
          const pending = res?.pending_count || 0;

          if (res?.success || res?.draft_status === 'drafted_in_gmail') {
            let note = `Sage Letter (Reminder ${reminder}) drafted into Drafts! ✉️`;
            if (reminder > 1) {
              note += ` (${resolved} resolved, ${newlyAdded} new, ${pending} pending)`;
            }
            this.toastr.success(note, 'Mail Drafted ✅');
          } else {
            this.toastr.warning(`Audit recorded, but IMAP draft status: ${res?.draft_status}`, 'Draft Warning ⚠️');
          }
          this.isDraftingEmail = false;

          // Clear the form and open the popup asking to exit or approve another
          this.clearClick(true);
          this.openAfterApproveDialog('Email Drafted!', 'Do you want to approve the next report?');
        },
        error: (err: any) => {
          console.error('Draft error email failed:', err);
          this.toastr.error('Failed to draft error email into mailbox. Please try again.', 'Draft Failed ❌');
          this.isDraftingEmail = false;
        }
      });

    } catch (draftErr) {
      console.error('Failed to capture error screenshots:', draftErr);
      this.toastr.error('Error during screenshot capture. Please try again.', 'Error ❌');
      this.isDraftingEmail = false;
    }
  }

  async viewDraftEmail() {
    if (!this.canDraftEmail) {
      this.toastr.warning('Drafting correction emails is restricted to Meraki administrators.', 'Access Restricted');
      return;
    }
    if (this.isLoadingDraftPreview) return;

    const payload = this.requestForm.getRawValue();
    const reportId = payload.json_report_id || this.requestForm.get('json_report_id')?.value;
    const vesselName = payload.vesselName || this.requestForm.get('vesselName')?.value || 'Vessel';
    const vesselIMO = payload.imoNumber || this.requestForm.get('imoNumber')?.value || 'N/A';
    const reportDate = payload.reportDate || 'N/A';
    const voyageNumber = payload.voyageNumber || 'N/A';
    const eventsList = payload.eventsList || 'N/A';

    if (!reportId) {
      this.toastr.warning('Please select or load a report first before previewing the draft email.');
      return;
    }
    // Emails go out only for reports that need correcting.
    if (!this.errorAvailable) {
      this.toastr.info('This report has nothing to correct, so no email is needed.', 'No Corrections');
      return;
    }

    this.isLoadingDraftPreview = true;
    this.toastr.info('Preparing draft email preview...', 'Draft Preview ✉️');

    try {
      let issues: any[] = [];
      if (this.errorAvailable) {
        issues = await this.captureErrorScreenshots();
      }

      const previewPayload = {
        id: reportId,
        to_email: payload.sourceEmail || this.requestForm.get('sourceEmail')?.value || '',
        cc_email: 'operations@merakishippingservices.com',
        vesselName: vesselName,
        vesselIMO: vesselIMO,
        eventsList: eventsList,
        reportDate: reportDate,
        reportHour: payload.reportHour,
        reportMinute: payload.reportMinute,
        issues: issues,
        errorCount: issues.length,
        errorsSummary: issues.map((c: any) => ({ label: c.label, error: c.errorMsg, key: c.fieldKey })),
        rawReport: payload
      };

      this.pRequestFormService.previewErrorEmail(previewPayload).subscribe({
        next: (res: any) => {
          this.isLoadingDraftPreview = false;
          if (res?.success) {
            // First confirm who the draft is for; only Yes opens the Draft Email popup.
            const confirmRef = this.dialog.open(DraftEmailConfirmPopupComponent, {
              width: '860px',
              maxWidth: '95vw',
              autoFocus: false,
              data: {
                vesselName,
                eventName: eventsList,
                reportDate,
                // The preview's list carries each issue's mail count; merge with captured issues for rich data (dataUrl, fieldKey).
                issues: Array.isArray(res.issues) && res.issues.length
                  ? res.issues.map((rIssue: any, idx: number) => {
                      const orig = issues.find((c: any) => (c.fieldKey && c.fieldKey === rIssue.fieldKey) || (c.label && c.label === rIssue.label)) || issues[idx] || {};
                      return {
                        ...orig,
                        ...rIssue,
                        fieldKey: rIssue.fieldKey || orig.fieldKey || orig.field,
                        label: rIssue.label || orig.label,
                        section: rIssue.section || orig.section,
                        message: rIssue.message || orig.errorMsg,
                        dataUrl: rIssue.dataUrl || orig.dataUrl,
                        selected: true,
                      };
                    })
                  : issues.map((c: any) => ({ ...c, label: c.label || c.fieldKey, section: c.section, message: c.errorMsg, selected: true })),
                errorCount: res.error_count,
                reminderLevel: res.reminder_level,
              },
            });
            confirmRef.afterClosed().subscribe(async (confirmResult?: any) => {
              const confirmed = typeof confirmResult === 'boolean' ? confirmResult : confirmResult?.confirmed;
              if (!confirmed) return;

              const selectedIssues = confirmResult?.selectedIssues && confirmResult.selectedIssues.length
                ? confirmResult.selectedIssues
                : issues;
              const unselectedKeys = confirmResult?.unselectedKeys || [];

              // If a subset of issues was selected, re-generate email preview so HTML only contains the selected issues
              let activePreview = res;
              if (selectedIssues.length < issues.length) {
                try {
                  const filteredPayload = {
                    ...previewPayload,
                    issues: selectedIssues,
                    errorCount: selectedIssues.length,
                    errorsSummary: selectedIssues.map((c: any) => ({ label: c.label || c.fieldKey, error: c.errorMsg || c.message, key: c.fieldKey || c.field })),
                    unselected_keys: unselectedKeys,
                  };
                  const rePreview = await this.pRequestFormService.previewErrorEmail(filteredPayload).toPromise();
                  if (rePreview?.success) {
                    activePreview = rePreview;
                  }
                } catch (prevErr) {
                  console.warn('Could not re-generate preview for selected issues, using initial preview:', prevErr);
                }
              }

              const dialogRef = this.dialog.open(ViewDraftEmailPopupComponent, {
                width: '95vw',
                maxWidth: '1200px',
                maxHeight: '94vh',
                panelClass: 'view-draft-email-dialog-panel',
                data: {
                  to: activePreview.to,
                  cc: activePreview.cc,
                  from: activePreview.from,
                  subject: activePreview.subject,
                  html: activePreview.html,
                  attachmentName: activePreview.attachment_name,
                  reminderLevel: activePreview.reminder_level,
                  errorCount: selectedIssues.length,
                  vesselName: vesselName,
                  canDraft: this.errorAvailable && !this.isDraftingEmail
                }
              });

              dialogRef.afterClosed().subscribe((result: any) => {
                if (result && (result.action === 'send' || result.action === 'draft')) {
                  this.draftErrorEmail({
                    to: result.to,
                    cc: result.cc,
                    subject: result.subject,
                    html: result.html,
                    comment: result.comment,
                    issues: selectedIssues,
                    unselected_keys: unselectedKeys
                  });
                }
              });
            });
          } else {
            this.toastr.error(res?.error || 'Failed to generate email preview.', 'Preview Error ❌');
          }
        },
        error: (err: any) => {
          this.isLoadingDraftPreview = false;
          console.error('Draft email preview failed:', err);
          this.toastr.error('Failed to generate draft email preview. Please try again.', 'Preview Error ❌');
        }
      });
    } catch (err) {
      this.isLoadingDraftPreview = false;
      console.error('Error preparing draft email preview:', err);
      this.toastr.error('Failed to prepare draft preview.', 'Error ❌');
    }
  }

  clearServerErrors() {
    this.serverFieldErrors = {};

    Object.keys(this.requestForm.controls).forEach((key) => {
      const ctrl = this.requestForm.get(key);
      if (!ctrl) return;

      if (ctrl.errors?.['serverError']) {
        const errors = { ...(ctrl.errors || {}) };
        delete errors['serverError'];

        ctrl.setErrors(Object.keys(errors).length ? errors : null);
      }
    });
  }

  // private applyServerErrorsToControls(apiRes: any) {
  //     const fieldErrors = apiRes?.errors?.fieldErrors || {};

  //     Object.keys(fieldErrors).forEach((fieldKey: string) => {
  //       const errObj = fieldErrors[fieldKey];

  //       const key = errObj?.key || fieldKey;
  //       const msg = errObj?.message || 'Invalid value';

  //       const ctrl = this.requestForm.get(key);

  //       if (ctrl) {
  //         ctrl.setErrors({
  //           ...(ctrl.errors || {}),
  //           backend: true
  //         });

  //         // ✅ store msg in control itself
  //         (ctrl as any).backendMessage = msg;

  //         ctrl.markAsTouched();
  //         ctrl.updateValueAndValidity({ emitEvent: false });
  //       }
  //     });
  //   }
  // private clearServerErrors() {
  //     Object.keys(this.requestForm.controls).forEach((key) => {
  //       const ctrl = this.requestForm.get(key);
  //       if (!ctrl?.errors) return;

  //       const newErrors = { ...ctrl.errors };

  //       if (newErrors['serverMessage']) delete newErrors['serverMessage'];
  //       if (newErrors['required']) delete newErrors['required'];

  //       ctrl.setErrors(Object.keys(newErrors).length ? newErrors : null);
  //       ctrl.updateValueAndValidity({ emitEvent: false });
  //     });
  //   }

  autoPopulateForm(report: any, data: any) {
    if (!report) return;
    this.clearServerErrorsTSOnly();
    this.errorAvailable = false;
    const patchObj: any = {
      json_report_id:
        report.json_report_id ?? report.jsonReportId ?? report.id ?? '',
      reportType: report.reportType ?? '',

      contractualSpeed: report.contractualSpeed ?? '',
      contractualConsumpFo: report.contractualConsumpFo ?? '',
      contractualConsumpGo: report.contractualConsumpGo ?? '',

      auxEngineOneHours: report.auxEngineOneHours ?? '',
      auxEngineOneKw: report.auxEngineOneKw ?? '',

      auxEngineTwoHours: report.auxEngineTwoHours ?? '',
      auxEngineTwoKw: report.auxEngineTwoKw ?? '',

      auxEngineThreeHours: report.auxEngineThreeHours ?? '',
      auxEngineThreeKw: report.auxEngineThreeKw ?? '',

      vesselName: report.vesselName ?? '',
      imoNumber: report.vesselIMO ?? report.imoNumber ?? '',
      vesselSegment: this.resolveSegment(report, data),
      vesselType: report.vesselType ?? '',
      vesselCondition: report.vesselCondition ?? '',
      voyageNumber: report.voyageNumber ?? '',
      merakiVoyageNumber: data.prevMerakiVoyageNumber ?? '',
      canEditMerakiVoyage: data.canEditMerakiVoyage ?? '',

      departurePort: report.departurePort ?? '',
      destinationPort: report.destinationPort ?? '',

      reportDate: report.reportDate ? this.toDateInput(report.reportDate) : '',
      reportHour: report.reportHour ?? '',
      reportMinute: report.reportMinute ?? '',
      portTimeZone: report.portTimeZone ?? '',

      eventsList: report.eventsList ?? '',
      operationInPort: report.operationInPort ?? '',

      etaOrderDate: report.etaOrderDate
        ? this.toDateInput(report.etaOrderDate)
        : '',
      etaOrderHour: report.etaOrderHour ?? '',
      etaOrderMinute: report.etaOrderMinute ?? '',

      etaWeatherDate: report.etaWeatherDate
        ? this.toDateInput(report.etaWeatherDate)
        : '',
      etaWeatherHour: report.etaWeatherHour ?? '',
      etaWeatherMinute: report.etaWeatherMinute ?? '',
      etaWeatherLthour: report.etaWeatherLthour ?? '',
      etaWeatherLtminute: report.etaWeatherLtminute ?? '',

      chartererName: report.chartererName ?? '',

      forwardDraftValue: report.forwardDraftValue ?? '',
      afterDraftValue: report.afterDraftValue ?? '',
      displacementValue: report.displacementValue ?? '',
      slopsRob: report.slopsRob ?? '',
      slopsTank: report.slopsTank ?? '',

      latitudeDegree: report.latitudeDegree ?? '',
      latitudeMin: report.latitudeMin ?? '',
      latitudeDir: report.latitudeDir ?? '',
      latitudeResult: report.latitudeResult ?? '',

      longitudeDegree: report.longitudeDegree ?? '',
      longitudeMin: report.longitudeMin ?? '',
      longitudeDir: report.longitudeDir ?? '',
      longitudeResult: report.longitudeResult ?? '',

      remainingDistance: report.remainingDistance ?? '',

      steamingDistanceGps: report.steamingDistanceGps ?? '',
      steamingHoursReport: report.steamingHoursReport ?? '',
      avgSpeedReport: report.avgSpeedReport ?? '',

      logDistanceReport: report.logDistanceReport ?? '',
      logSpeedReport: report.logSpeedReport ?? '',
      avgCourseReport: report.avgCourseReport ?? '',

      totalDistanceGps: report.totalDistanceGps ?? '',
      totalVoyageHours: report.totalVoyageHours ?? '',
      overallAverageSpeed: report.overallAverageSpeed ?? '',

      engineLogDistance: report.engineLogDistance ?? '',
      slipPercentage: report.slipPercentage ?? '',

      mainEngineRpm: report.mainEngineRpm ?? '',
      engineAverageBhp: report.engineAverageBhp ?? '',
      meRevolutionCounter: report.meRevolutionCounter ?? '',
      engineSpeed: report.engineSpeed ?? '',
      engineLoadPercent: report.engineLoadPercent ?? '',
      meRunningHours: report.meRunningHoursSinceLastReport ?? '',
      erTemp: report.erTemp ?? '',
      scavengeAirPress: report.scavengeAirPress ?? '',
      scavengeAirTemp: report.scavengeAirTemp ?? '',
      airCoolerTemp: report.airCoolerTemp ?? '',
      trueWindDirection: report.trueWindDirection ?? '',
      trueWindKnots: report.trueWindKnots ?? '',
      windForceBf: report.windForceBf ?? '',
      windDescriptionSelect: report.windDescriptionSelect ?? '',
      relativeWindSpeedKnots: report.relativeWindSpeedKnots ?? '',
      relativeWindDirectionDegrees: report.relativeWindDirectionDegrees ?? '',

      swellDirection: report.swellDirection ?? '',
      swellHeightMeter: report.swellHeightMeter ?? '',
      seaHeightMeter: report.seaHeightMeter ?? '',

      trueSeaDirection: report.trueSeaDirection ?? '',
      currentDirectionSelect: report.currentDirectionSelect ?? '',
      currentKnots: report.currentKnots ?? '',

      airTemperature: report.airTemperature ?? '',
      seaTemperature: report.seaTemperature ?? '',
      pressureMbar: report.pressureMbar ?? '',

      freshWaterRob: report.freshWaterRob ?? '',
      distilledWaterQty: report.distilledWaterQuantityMt ?? '',

      reeferCount: report.reeferCount ?? '',
      reeferKwh: report.reeferKwh ?? '',

      voyageRemarks: report.voyageRemarks ?? '',

      // ✅ MGO FIX
      mgoMeConsumption: report.mgoMeConsumption ?? '',
      mgoAeConsumption: report.mgoAeConsumption ?? '',
      mgoBlrConsumption: report.mgoBlrConsumption ?? '',
      mgoOthersConsumptionType: report.mgoOthersConsumptionType ?? '',
      mgoOthersConsumptionQuantity: report.mgoOthersConsumptionQuantity ?? '',
      mgoTotalConsumption: report.mgoTotalConsumption ?? '',
      mgoBunkerRob: report.mgoBunkerRob ?? '',

      gasOilPowerPack: report.gasOilPowerPack ?? '',
      incineratorGasOil: report.incineratorGasOil ?? '',
      inertingGasOil: report.inertingGasOil ?? '',

      // ✅ OLD ROB
      mgoMeOldRob: report.mgoMeOldRob ?? '',
      mgoAeOldRob: report.mgoAeOldRob ?? '',
      mgoBlrOldRob: report.mgoBlrOldRob ?? '',
      mgoTotalOldRob: report.mgoTotalOldRob ?? '',
      lngTotalOldRob: report.lngTotalOldRob ?? '',

      copOneRpm: report.copOneRpm ?? report.cop_one_rpm ?? '',
      copTwoRpm: report.copTwoRpm ?? report.cop_two_rpm ?? '',
      copThreeRpm: report.copThreeRpm ?? report.cop_three_rpm ?? '',
      hydraulicSysPressure: report.hydraulicSysPressure ?? report.hydraulic_sys_pressure ?? '',
      formRevision: report.formRevision ?? report.form_revision ?? 1,
      revisionChain: report.revisionChain ?? report.revision_chain ?? [],
      finalSubmitTimeUTC: report.finalSubmitTimeUTC ?? report.final_submit_time_utc ?? '',
      totalShaftPower: report.totalShaftPower ?? report.total_shaft_power ?? '',
      driftingDistance: report.driftingDistance ?? report.drifting_distance ?? '',
      etdCurrentPortDate: report.etdCurrentPortDate ? this.toDateInput(report.etdCurrentPortDate) : '',

    };

    this.requestForm.patchValue(patchObj, { emitEvent: false });
    this.applyReportTypeLogic();
    const voyageControl = this.requestForm.get('merakiVoyageNumber');
    const canEditMerakiVoyage = this.requestForm.get('canEditMerakiVoyage');

    if (canEditMerakiVoyage?.value) {
      voyageControl?.enable();
    } else {
      voyageControl?.disable();
    }

    // ✅ CARGO ARRAY
    this.cargoDetails.clear();
    if (Array.isArray(report.cargoDetails) && report.cargoDetails.length > 0) {
      report.cargoDetails.forEach((c: any) => {
        this.cargoDetails.push(
          this.fb.group({
            name: [c.name ?? ''],
            quantity: [c.quantity ?? ''],
          }),
        );
      });
    } else {
      this.cargoDetails.push(this.fb.group({ name: [''], quantity: [''] }));
    }

    this.fuelOilData.clear();
    if (Array.isArray(report.fuelOilData) && report.fuelOilData.length > 0) {
      report.fuelOilData.forEach((f: any) => {
        this.fuelOilData.push(
          this.fb.group({
            fuelType: [f.fuelType ?? ''],
            meConsumption: [f.meConsumption ?? ''],
            aeConsumption: [f.aeConsumption ?? ''],
            blrConsumption: [f.blrConsumption ?? ''],
            othersType: [f.otherReason ?? ''],
            othersQty: [f.otherConsumption ?? ''],
            totalConsumption: [f.totalConsumption ?? ''],
            bunkerRob: [f.bunkerRob ?? ''],
          }),
        );
      });
    } else {
      this.fuelOilData.push(
        this.fb.group({
          fuelType: [''],
          meConsumption: [''],
          aeConsumption: [''],
          blrConsumption: [''],
          othersType: [''],
          othersQty: [''],
          totalConsumption: [''],
          bunkerRob: [''],
        }),
      );
    }

    if (Array.isArray(report.bunkerGrades)) {
      this.requestForm.patchValue(
        {
          bunkerGrade1: report.bunkerGrades[0]?.grade ?? '',
          quantity1: report.bunkerGrades[0]?.qty ?? '',
          descrepency1: report.bunkerGrades[0]?.desc ?? '',

          bunkerGrade2: report.bunkerGrades[1]?.grade ?? '',
          quantity2: report.bunkerGrades[1]?.qty ?? '',
          descrepency2: report.bunkerGrades[1]?.desc ?? '',

          bunkerGrade3: report.bunkerGrades[2]?.grade ?? '',
          quantity3: report.bunkerGrades[2]?.qty ?? '',
          descrepency3: report.bunkerGrades[2]?.desc ?? '',
        },
        { emitEvent: false },
      );
    }

    console.log(' FINAL FORM VALUE:', this.requestForm.value);
  }
  createFuelOilRow(data?: any): FormGroup {
    return this.fb.group({
      fuelType: [data?.fuelType || '', Validators.required],
      meConsumption: [data?.meConsumption || ''],
      aeConsumption: [data?.aeConsumption || ''],
      othersType: [data?.othersType || ''],
      othersQty: [data?.othersQty || ''],
      blrConsumption: [data?.blrConsumption || ''],
      totalConsumption: [
        { value: data?.totalConsumption || '', disabled: true },
      ],
      bunkerRob: [data?.bunkerRob || ''],
    });
  }

  addFuelOilRow() {
    this.fuelOilData.push(this.createFuelOilRow());
  }

  removeFuelOilRow(i: number) {
    if (this.fuelOilData.length > 1) {
      this.fuelOilData.removeAt(i);
    }
  }

  calculateFuelTotal(i: number) {
    const row = this.fuelOilData.at(i) as FormGroup;

    const me = parseFloat(row.get('meConsumption')?.value) || 0;
    const ae = parseFloat(row.get('aeConsumption')?.value) || 0;
    const blr = parseFloat(row.get('blrConsumption')?.value) || 0;
    const other = parseFloat(row.get('othersQty')?.value) || 0;

    const total = me + ae + blr + other;
    row
      .get('totalConsumption')
      ?.setValue(total.toFixed(2), { emitEvent: false });
  }

  addCargoRow() {
    this.cargoDetails.push(
      this.fb.group({
        name: [''],
        quantity: [''],
      }),
    );
  }

  removeCargoRow(index: number) {
    if (this.cargoDetails.length > 1) {
      this.cargoDetails.removeAt(index);
    }
  }
  calculateLatitude() {
    const deg = parseFloat(this.requestForm.get('latitudeDegree')?.value) || 0;
    let min = parseFloat(this.requestForm.get('latitudeMin')?.value) || 0;
    const dir = this.requestForm.get('latitudeDir')?.value;

    if (min >= 60) min = 59.99;

    let decimal = deg + min / 60;
    if (dir === 'S') decimal *= -1;

    this.requestForm
      .get('latitudeResult')
      ?.setValue(decimal.toFixed(2), { emitEvent: false });
  }

  calculateLongitude() {
    const deg = parseFloat(this.requestForm.get('longitudeDegree')?.value) || 0;
    let min = parseFloat(this.requestForm.get('longitudeMin')?.value) || 0;
    const dir = this.requestForm.get('longitudeDir')?.value;

    if (min >= 60) min = 59.99;

    let decimal = deg + min / 60;
    if (dir === 'W') decimal *= -1;

    this.requestForm
      .get('longitudeResult')
      ?.setValue(decimal.toFixed(2), { emitEvent: false });
  }
  calculateAvgSpeed() {
    const steamingDistance =
      parseFloat(this.requestForm.get('steamingDistanceGps')?.value) || 0;
    const steamingHours =
      parseFloat(this.requestForm.get('steamingHoursReport')?.value) || 0;
    const logDistance =
      parseFloat(this.requestForm.get('logDistanceReport')?.value) || 0;

    let avgSpeed = 0;
    if (steamingHours > 0) avgSpeed = steamingDistance / steamingHours;

    this.requestForm
      .get('avgSpeedReport')
      ?.setValue(avgSpeed.toFixed(2), { emitEvent: false });

    let logSpeed = 0;
    if (steamingHours > 0) logSpeed = logDistance / steamingHours;

    this.requestForm
      .get('logSpeedReport')
      ?.setValue(logSpeed.toFixed(2), { emitEvent: false });
  }

  calculateSpeed() {
    const totalDistance =
      parseFloat(this.requestForm.get('totalDistanceGps')?.value) || 0;
    const totalHours =
      parseFloat(this.requestForm.get('totalVoyageHours')?.value) || 0;

    let overallAvg = 0;
    if (totalHours > 0) overallAvg = totalDistance / totalHours;

    this.requestForm
      .get('overallAverageSpeed')
      ?.setValue(overallAvg.toFixed(2), { emitEvent: false });
  }

  calculateSlip() {
    const engineDistance =
      parseFloat(this.requestForm.get('engineLogDistance')?.value) || 0;
    const gpsDistance =
      parseFloat(this.requestForm.get('steamingDistanceGps')?.value) || 0;

    let slip = 0;
    if (engineDistance > 0) {
      slip = ((engineDistance - gpsDistance) / engineDistance) * 100;
    }

    this.requestForm
      .get('slipPercentage')
      ?.setValue(slip.toFixed(2), { emitEvent: false });
  }
  validateDecimal(controlName: string) {
    const ctrl = this.requestForm.get(controlName);
    if (!ctrl) return;

    const value = (ctrl.value || '').toString();
    const regex = /^\d*\.?\d{0,2}$/;

    if (!regex.test(value)) {
      ctrl.setValue(value.slice(0, -1), { emitEvent: false });
      this.decimalErrors[controlName] = true;
    } else {
      this.decimalErrors[controlName] = false;
    }
  }

  validatePressureAngular() {
    const ctrl = this.requestForm.get('pressureMbar');
    if (!ctrl) return;

    let value = (ctrl.value || '').toString().replace(/\D/g, '').slice(0, 4);
    ctrl.setValue(value, { emitEvent: false });

    const regex = /^[1-9]\d{3}$/;
    this.pressureError = value ? !regex.test(value) : false;
  }

  toDateInput(value: any): string {
    if (!value) return '';

    if (typeof value === 'string' && value.includes(',')) {
      const date = new Date(value);
      if (!isNaN(date.getTime())) return date.toISOString().split('T')[0];
    }

    if (typeof value === 'string' && value.length >= 10) {
      return value.substring(0, 10);
    }

    return '';
  }

  get cargoDetails(): FormArray {
    return this.requestForm.get('cargoDetails') as FormArray;
  }

  get fuelOilData(): FormArray {
    return this.requestForm.get('fuelOilData') as FormArray;
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  calculateMgoTotal() {
    const me = parseFloat(this.requestForm.get('mgoMeConsumption')?.value) || 0;
    const ae = parseFloat(this.requestForm.get('mgoAeConsumption')?.value) || 0;
    const blr =
      parseFloat(this.requestForm.get('mgoBlrConsumption')?.value) || 0;
    const others =
      parseFloat(this.requestForm.get('mgoOthersConsumptionQuantity')?.value) ||
      0;

    const gasOilPowerPack =
      parseFloat(this.requestForm.get('gasOilPowerPack')?.value) || 0;
    const incineratorGasOil =
      parseFloat(this.requestForm.get('incineratorGasOil')?.value) || 0;
    const inertingGasOil =
      parseFloat(this.requestForm.get('inertingGasOil')?.value) || 0;

    const total =
      me +
      ae +
      blr +
      others +
      gasOilPowerPack +
      incineratorGasOil +
      inertingGasOil;

    this.requestForm
      .get('mgoTotalConsumption')
      ?.setValue(total.toFixed(2), { emitEvent: false });
  }

  showMap = false;
  map!: L.Map;
  marker!: L.Marker;

  toggleMap(): void {
    this.showMap = !this.showMap;

    if (this.showMap) {
      setTimeout(() => this.initMap(), 0);
    } else {
      this.map?.remove();
    }
  }

  initMap(): void {
    const lat = Number(this.requestForm.get('latitudeResult')?.value);
    const lon = Number(this.requestForm.get('longitudeResult')?.value);

    this.map = L.map('routeMap', {
      center: [lat, lon],
      zoom: 4.5,
      zoomControl: true,
      attributionControl: false,
    });

    L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
      { maxZoom: 19 },
    ).addTo(this.map);

    this.initMarkers();

    setTimeout(() => {
      this.map.invalidateSize();
    }, 200);

    // 🔁 resize icon on zoom
    this.map.on('zoomend', () => this.initMarkers());
  }

  initMarkers(): void {
    const lat = Number(this.requestForm.get('latitudeResult')?.value);
    const lon = Number(this.requestForm.get('longitudeResult')?.value);
    const ship = this.requestForm.get('vesselName')?.value;
    const zoom = this.map.getZoom();

    if (this.marker) {
      this.marker.remove();
    }

    this.marker = L.marker([lat, lon], {
      icon: this.createIcon(
        'Laden', // or Ballast if needed
        ship,
        zoom,
        false,
        false,
      ),
    }).addTo(this.map);
  }

  isLatLongValid(): boolean {
    return (
      !!this.requestForm.get('latitudeResult')?.value &&
      !!this.requestForm.get('longitudeResult')?.value
    );
  }

  createIcon(
    voyageType: string,
    shipName: string,
    zoomLevel: number,
    showRedFlag: boolean,
    showGrayFlag: boolean,
  ): L.DivIcon {
    const size = this.getIconSize(zoomLevel);
    const color = voyageType === 'Ballast' ? 'blue' : '#7c2020';

    const flagHtml = showRedFlag
      ? '<i class="fa fa-flag" style="color: red; position: absolute; top: -52%; left: 86%;"></i>'
      : showGrayFlag
        ? '<i class="fa fa-flag" style="color: gray; position: absolute; top: -52%; left: 86%;"></i>'
        : '';

    return L.divIcon({
      className: `custom-icon ${voyageType.toLowerCase()}-icon`,
      html: `
      <div class="icon-wrapper">
        <i class="fa-sharp fa-solid fa-ship"
           style="color: ${color}; font-size: ${size}px;"></i>
        ${flagHtml}
        <div class="ship-name">${shipName}</div>
      </div>
    `,
      iconSize: [size, size],
      iconAnchor: [size / 2, size],
      popupAnchor: [0, -size],
    });
  }

  getIconSize(zoomLevel: number): number {
    return Math.min(Math.max(zoomLevel * 2, 12), 40);
  }

  applySuggestion(field: 'departurePort' | 'destinationPort', suggestedName: string) {
    this.requestForm.get(field)?.setValue(suggestedName);
    // After applying, we can either clear the suggestion or call updatePortInBackend
    // Let's call updatePortInBackend to propagate if needed
    this.updatePortInBackend(field, suggestedName, false);
  }

  ignoreSuggestion(field: 'departurePort' | 'destinationPort') {
    if (this.portSuggestions && this.portSuggestions[field]) {
      this.portSuggestions[field] = null;
    }
  }

  updatePortInBackend(field: 'departurePort' | 'destinationPort', newName: string, addToMaster: boolean = false, data?: any) {
    const jsonReportId = this.requestForm.get('json_report_id')?.value;
    const imo = this.requestForm.get('imoNumber')?.value;
    const voyageNumber = this.requestForm.get('voyageNumber')?.value;

    // Get the current value in the form or the original from suggestions
    const oldValue = this.portSuggestions?.[field]?.original || this.requestForm.get(field)?.value || '';

    if (!jsonReportId) return;

    let propagate = false;

    // If the name is being changed, ask for propagation
    if (newName !== oldValue) {
      propagate = confirm("Do you want to update this port name for all subsequent pending reports in this voyage?");
    }
    // Note: If newName === oldValue (e.g. just adding to master), propagate stays false 
    // and we don't annoy the user with a confirm dialog.

    this.isSubmitting = true;
    this.pRequestFormService.updatePort({
      json_report_id: jsonReportId,
      vesselIMO: imo,
      voyageNumber: voyageNumber,
      field: field,
      oldValue: oldValue,
      newName: newName,
      propagate: propagate,
      addToMaster: addToMaster,
      latitude: data?.latitude,
      longitude: data?.longitude
    }).subscribe({
      next: (res) => {
        this.isSubmitting = false;
        this.toastr.success(res.message || 'Port updated successfully');

        // Update the form control to reflect the new resolved/updated port name
        this.requestForm.get(field)?.setValue(newName, { emitEvent: false });

        if (this.portSuggestions) {
          this.portSuggestions[field] = null;
        }
      },
      error: (err) => {
        this.isSubmitting = false;
        this.toastr.error(err.error?.error || 'Failed to update port');
      }
    });
  }

  addNewPortToMaster(field: 'departurePort' | 'destinationPort') {
    const portName = this.requestForm.get(field)?.value || this.portSuggestions?.[field]?.original || '';
    if (!portName) return;

    const dialogRef = this.dialog.open(PortsPopupComponent, {
      width: '500px',
      data: { port_name: portName, disableApiCall: true }
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res && res.event === 'success') {
        const newName = res.data.port_name || portName;
        // The popup handles adding raw data, but to link it to THIS report, update port in backend too.
        this.updatePortInBackend(field, newName, true, res.data);
      }
    });
  }
}
